import { Injectable } from '@angular/core';

@Injectable()
export class ArrayParsingUtils {
  public parseArrayFromJsonString(json: string): Array<any> {
    try {
      if (typeof json !== 'string') {
        return json;
      }
      let isString = true;
      let el = JSON.parse(json) as any;
      if (typeof el === 'string') {
        while (isString) {
          el = JSON.parse(el);
          if (typeof el !== 'string') {
            isString = false;
          }
        }
      }
      return el as Array<any>;
    } catch (e) {
      console.log(e);
      return null;
    }
  }
}
